import { Component, Input, Output, ViewChild, EventEmitter, ViewEncapsulation } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { EnvoirnmentService } from "../../services/envoirnment.service";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MultiLanguageService } from "../multi-language/multi-language.service";

@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.scss"],
  encapsulation: ViewEncapsulation.Emulated, 
})
export class FooterComponent {
  footerDate = new Date();
  medcareVersion: String;

  private isRefreshing = false;
  @Input() showFooter: boolean = false; 
  @Input() totalDataLength: number = 0;
  @Input() pageSize: number = 0;
  @Input() pageIndex: number = 0;
  @Input() paginatorOptions: number[] = [];

  @Output() pageChange = new EventEmitter<PageEvent>();

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @Output() refresh = new EventEmitter<void>();

  constructor(
    public translate: TranslateService,
    private env: EnvoirnmentService,
    private langService: MultiLanguageService,
    
  ) {
    this.medcareVersion = this.env.medcareVerison;
  }
  ngAfterViewInit() {
     this.langService.changeFooterLabel().then((val) => {
       if (this.paginator) {
       this.paginator._intl.itemsPerPageLabel = val.footerLabel;
       this.paginator._intl.firstPageLabel = val.firstPageLabel;
       this.paginator._intl.lastPageLabel = val.lastPageLabel;
       this.paginator._intl.nextPageLabel = val.nextPageLabel;
       this.paginator._intl.previousPageLabel = val.previousPageLabel;
       this.paginator._intl.changes.next();
      }
   });
  }
  getNext(event: PageEvent): void {
    if (!this.isRefreshing) {
      this.pageChange.emit(event); 
    }
  }
  onRefreshClick(): void {
    this.isRefreshing = true; 
    this.paginator.pageIndex = this.pageIndex;
    this.paginator.pageSize = this.pageSize;
    this.paginator.firstPage();
    this.refresh.emit();
    setTimeout(() => (this.isRefreshing = false), 0);
  }
  getStartIndex(): number {
    const pageIndex = this.pageIndex ?? 0;
    const pageSize = this.pageSize ?? 0;
    return pageIndex * pageSize;
  }

  getEndIndex(): number {
    const start = this.getStartIndex();
    const pageSize = this.pageSize ?? 0;
    const total = this.totalDataLength ?? 0;
    const end = start + pageSize;
    return end > total ? total : end;
  }
  totalPages(): number {
    const totalDataLength = this.totalDataLength ?? 0;
    const pageSize = this.pageSize ?? 0;
    return Math.ceil(totalDataLength / pageSize);
  }
    
}
